enum TimeSpanEnum {
  Thirty = 30,
  Sixty = 60,
  Ninety = 90,
}

export default TimeSpanEnum;
